export enum EVENT_NAME {
  SUPPORT_SUCCESSFUL = 'support - support successful',
  SUPPORT_FAILED = 'support - support failed',
  SUPPORT_CLICK_CANCEL = 'support - click cancel',
  SUPPORT_CLICK_SUPPORT = 'support - click support',
  SUPPORT_CLICK_CONFIRM = 'support - click confirm support',
  SUPPORT_CHANGE_PERIOD = 'support - change period',
  SUPPORT_CLICK_CONFIRM_PERIOD = 'support - click confirm period',
  SUPPORT_CLICK_CONFIRM_RECEIVER_INFORMATION = 'support - click confirm receiver information',
  SUPPORT_ENTER_THANK_YOU_PAGE = 'support - enter thank you page',
  PAYMENT_MANAGEMENT_ADD_CARD = 'payment management - add card',
  PAYMENT_MANAGEMENT_CHANGE_DEFAULT_CARD = 'payment management - change default card',
  PAYMENT_MANAGEMENT_CLICK_DELETE_CARD = 'payment management - click delete card',
  VIEW_HOME_PAGE = 'home - view home page',
  VIEW_HOME_PAGE_PROXY = 'home - view home page - PROXY',
  VIEW_CATEGORY = 'view category',
  VIEW_CAMPAIGN = 'view campaign',
  VIEW_IMPACTER = 'view impacter',
  VIEW_DONATE_PAGE = 'home - view donate page',
  VIEW_CONFIRM_DONATION_PAGE = 'home - view confirm donation page',
  VIEW_POST_PAGE = 'view post page',
  VIEW_VIDEO = 'view video',
  VIEW_VIDEO_COMPLETED = 'video viewed',
  CLICK_APP_DOWNLOAD = 'click app download',
  CLICK_SHARE_LINK = 'share - click share link',
  SHARE_LINK_SUCCESS = 'share - share link success',
  SHARE_LINK_CANCEL = 'share - share link cancel',
  SIGN_UP_VIEW_PAGE = 'sign up - view sign up page',
  SIGN_UP_CLICK_SIGN_UP = 'sign up - click sign up button',
  SIGN_UP_ACCOUNT_CREATED = 'sign up - account created',
  SIGN_UP_ACCOUNT_FAILED = 'sign up - account failed',
  LOGIN_VIEW_PAGE = 'login - view login page',
  LOGIN_CLICK_PASSWORD_LOGIN_BUTTON = 'login - click password login button',
  LOGIN_LOGIN = 'login - login',
  LOGIN_LOGIN_FAILED = 'login - login failed',
  LOGOUT = 'logout',
  GIFTING_VIEW_GIFT = 'gifting - view gift page',
  GIFTING_VIEW_BUY_GIFT = 'gifting - view buy gift page',
  GIFTING_VIEW_REDEEM = 'gifting - view redeem page',
  GIFTING_VIEW_REDEEM_FLOW = 'gifting - view redeem flow page',
  GIFTING_CLICK_CONFIRM_CATEGORY = 'gifting - click confirm category',
  GIFTING_CLICK_CONFIRM_REDEEM_GIFT = 'gifting - click confirm gift redemption',
  GIFTING_REDEEM_GIFT_SUCCESSFUL = 'gifting - redeem gift successful',
  GIFTING_REDEEM_GIFT_FAILED = 'gifting - redeem gift failed',
  GIFTING_VIEW_REDEEM_THANK_YOU = 'gifting - view redeem gift thank you',
  WEB_SESSION_START = 'web - session start',
  BUTTON_CLICK = 'click button',
  FIREBASE_SIGNIN_REDIRECT_SUCCESSFUL = 'firebase - sign-in redirect successful',
  FIREBASE_SIGNIN_REDIRECT_FAILED = 'firebase - sign-in redirect failed',
  FIREBASE_ACCOUNT_CREATED_SUCCESSFUL = 'firebase - account created successful',
  FIREBASE_ACCOUNT_CREATED_FAILED = 'firebase - account created failed',
  FIREBASE_AUTH_STATE_CHANGED = 'firebase - auth state changed',
  NAVIGATION = 'navigation',
  VIEW_CREATE_ACCOUNT = 'view create account',
  VIEW_ENTER_PASSWORD = 'view enter password',
  VIEW_PAYOUT_OVERVIEW = 'impacter tools - view payout overview',
  VIEW_SINGLE_PAYOUT = 'impacter tools - view single payout',
  VIEW_SUPPORT_OVERVIEW = 'impacter tools - view support overview',
  VIEW_MONTH_FINANCIAL_DETAILS = 'impacter tools - view month financial details',
  DOWNLOAD_FILE = 'impacter tools - download file',
  START_PAYMENT_FLOW = 'support - start payment flow',
  VIEW_BLOG_POST = 'blog - read blog post',
  SHARE_BLOG_POST = 'blog - share blog post',

  // Event names for New Create flow:
  CREATE_POST_VIEW_CREATE = 'create post - view create',
  CREATE_POST_VIEW_MANAGE_POSTS = 'create post - view manage posts',
  CREATE_POST_START_POST = 'create post - start new post',
  CREATE_POST_FILE_ADDED = 'create post - file added',
  CREATE_POST_FILE_REMOVED = 'create post - file removed',
  CREATE_POST_UPLOAD_ERROR = 'create post - upload error',
  CREATE_POST_UPLOAD_START = 'create post - upload start',
  CREATE_POST_UPLOAD_SUCCESS = 'create post - upload success',
  CREATE_POST_UPLOAD_RETRY = 'create post - upload retry',
  CREATE_POST_PUBLISH_STARTED = 'create post - publish started',
  CREATE_POST_PUBLISH_SUCCESS = 'create post - publish succeeded',
  CREATE_POST_PUBLISH_ERROR = 'create post - publish error',
  CREATE_POST_POST_ADDED = 'create post - post added',
  CREATE_POST_GO_BACK_TO_OLD_CREATE = 'create post - go to old create',
  UNSUPPORTED_BROWSER = 'unsupported browser',

  // Server events
  HTTP_NOT_OK = 'http not ok',
}
